import { render } from "./PoliticaComp.vue?vue&type=template&id=6cf9e248&scoped=true"
import script from "./PoliticaComp.vue?vue&type=script&lang=js"
export * from "./PoliticaComp.vue?vue&type=script&lang=js"

import "./PoliticaComp.vue?vue&type=style&index=0&id=6cf9e248&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf9e248"]])

export default __exports__